import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';

import CanvasCard from '../../common/components/canvas-card';
import DomainGroupingOverview from './domain-grouping-overview';

import { openBaseDomainGroupingModal, openEditDomainGroupingModal } from '../../common/actions/modal-action-creators';
import { deleteDomainGroup } from '../../common/actions/domain-groups-action-creators';
import { domainGroupsSelector, domainGroupsIsLoading } from '../../common/selectors/domain-groups-selectors';

export const defaultMessageComponent = ( classes ) => {
    return (
        <React.Fragment>
            <div className={classes.noContent}>
                <IconButton
                    color="inherit"
                    className={classes.warningIcon}
                >
                    <InfoOutlinedIcon/>
                </IconButton >
                <Typography>To start, click GROUP DOMAINS.</Typography>
                <Typography>
                    You can then create a canvas to monitor data of a domain group under Workspaces.
                </Typography>
            </div>
        </React.Fragment>
    );
};

const styles = theme => ( {
    noContent: {
        textAlign: 'center',
        width: '100%'
    },
    warningIcon: {
        color: theme.palette.text['secondary'],
        height: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit,
        width: theme.spacing.unit * 3,
    },
} );

export const DomainGroupingOverviewContainer = ( {
    classes,
    domainGroupingIsLoading,
    openBaseDomainGroupingModal,
    openEditDomainGroupingModal,
    domainGroupingData,
    deleteDomainGroup
} ) => {
    const header = {
        buttonAction: openBaseDomainGroupingModal,
        buttonText: 'Group Domains',
        title: 'Domain Grouping',
    };
    return (
        <CanvasCard
            header={header}
            isLoading={domainGroupingIsLoading}
            defaultMessageComponent={ defaultMessageComponent( classes ) }
            noContentPadding={!!domainGroupingData.length}
            automationId="domain-grouping-overview"
        >
            {
                domainGroupingData.length &&
                ( <DomainGroupingOverview
                    domainGroupingData={domainGroupingData}
                    deleteGroup={deleteDomainGroup}
                    editGroup={openEditDomainGroupingModal}
                /> )
            }
        </CanvasCard>
    );
};

DomainGroupingOverviewContainer.propTypes = {
    classes: PropTypes.object.isRequired,
    deleteDomainGroup: PropTypes.func.isRequired,
    domainGroupingData: PropTypes.array.isRequired,
    domainGroupingIsLoading: PropTypes.bool.isRequired,
    openBaseDomainGroupingModal: PropTypes.func.isRequired,
    openEditDomainGroupingModal: PropTypes.func.isRequired,
};

/* istanbul ignore next */
const mapStateToProps = ( state, props ) => ( {
    domainGroupingData: domainGroupsSelector( state, props ),
    domainGroupingIsLoading: domainGroupsIsLoading( state, props ),
} );

const mapDispatchToProps = {
    deleteDomainGroup,
    openBaseDomainGroupingModal,
    openEditDomainGroupingModal
};

export default connect( mapStateToProps, mapDispatchToProps )( withStyles( styles )(
    DomainGroupingOverviewContainer
) );
